import angular from 'angular';
import uiRouter from 'angular-ui-router';
import NewComponent from './new.component';
import routing from './new.routes';

export default angular
  .module('verifyApp.cases.new', [uiRouter])
  .config(routing)
  .component('new', NewComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/new/index.js